<template>
  <div class="right-side-nav">
    <div class="div-block-165">
      <div class="div-block-11">
        <div class="div-block-5">
          <div class="div-block-6">
            <!--            <div >-->
            <img
              v-if="'customerDisplayPicture' in customerInfo"
              :src="customerInfo.customerDisplayPicture"
              class="image-profile-pic"
            />
            <!--            </div>-->
            <div class="text-block-8" v-else>
              {{ userInfo.customerFirstName.charAt(0)
              }}{{ userInfo.customerLastName.charAt(0) }}
            </div>
          </div>
          <div>
            <div class="text-block-6">
              {{ userInfo.customerFirstName }} {{ userInfo.customerLastName }}
            </div>
            <div class="text-block-7">
              <div @click="goToProfile" class="link-2">View profile</div>
            </div>
          </div>
        </div>
      </div>
      <div class="suggested-pro-empty">
        <div>
          <div class="div-block-12">
            <img
              src="@/assets/timeslot-images/explore.png"
              loading="lazy"
              width="108"
              alt=""
              class="image-3"
            />
            <div class="text-block-9">Suggested Professionals</div>
            <div class="text-block-10">
              Based on your expertise, we feel you may be interested in these
              professionals
            </div>
            <router-link to="/discover" class="timeslot-button w-button"
              >Explore</router-link
            >
          </div>
        </div>
      </div>
      <div class="suggested-pro">
        <div>
          <div class="div-block-12-copy">
            <div class="text-block-9-copy">Suggested Professionals</div>
            <a
              @click="profile(professional)"
              class="div-block-99 w-inline-block"
              v-for="(professional, index) in professionalList.slice(0, 3)"
              :key="index"
            >
              <!--              src="@/assets/timeslot-images/profile-picture.png"-->
              <div class="div-block-100">
                <img
                  :src="
                    professional.customerDisplayPicture.includes('https')
                      ? professional.customerDisplayPicture
                      : require('@/assets/timeslot-images/profileImg.svg')
                  "
                  loading="lazy"
                  width="45"
                  alt=""
                  class="image-23"
                />
                <div class="profile-name">
                  <a @click="profile(professional)" class="text-block-79">{{
                    professional.customerName
                  }}</a>
                  <div class="text-block-80">
                    {{ professional.professionalSubCategory }}
                  </div>
                </div>
              </div>
              <div>
                <img
                  src="@/assets/timeslot-images/back.svg"
                  loading="lazy"
                  alt=""
                />
              </div>
            </a>
            <!--            <router-link-->
            <!--              to="/professional-profile"-->
            <!--              class="div-block-99 w-inline-block"-->
            <!--            >-->
            <!--              <div class="div-block-100">-->
            <!--                <img-->
            <!--                  src="@/assets/timeslot-images/profile-picture.png"-->
            <!--                  loading="lazy"-->
            <!--                  width="45"-->
            <!--                  alt=""-->
            <!--                  class="image-23"-->
            <!--                />-->
            <!--                <div>-->
            <!--                  <div class="text-block-79">Idris Yusuf</div>-->
            <!--                  <div class="text-block-80">Product Designer</div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--              <div>-->
            <!--                <img-->
            <!--                  src="@/assets/timeslot-images/back.svg"-->
            <!--                  loading="lazy"-->
            <!--                  alt=""-->
            <!--                />-->
            <!--              </div>-->
            <!--            </router-link>-->
            <!--            <router-link-->
            <!--              to="/professional-profile"-->
            <!--              class="div-block-99 w-inline-block"-->
            <!--            >-->
            <!--              <div class="div-block-100">-->
            <!--                <img-->
            <!--                  src="@/assets/timeslot-images/profile-picture.png"-->
            <!--                  loading="lazy"-->
            <!--                  width="45"-->
            <!--                  alt=""-->
            <!--                  class="image-23"-->
            <!--                />-->
            <!--                <div>-->
            <!--                  <div class="text-block-79">Idris Yusuf</div>-->
            <!--                  <div class="text-block-80">Product Designer</div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--              <div>-->
            <!--                <img-->
            <!--                  src="@/assets/timeslot-images/back.svg"-->
            <!--                  loading="lazy"-->
            <!--                  alt=""-->
            <!--                />-->
            <!--              </div>-->
            <!--            </router-link>-->
            <router-link to="/discover" class="link-block-10 w-inline-block">
              <div>View more</div>
            </router-link>
          </div>
        </div>
      </div>
      <div>
        <div>
          <div class="div-block-12">
            <img
              src="@/assets/timeslot-images/Group-36721.png"
              loading="lazy"
              width="108"
              alt=""
              class="image-3"
            />
            <div class="text-block-9">Become a Professional</div>
            <div class="text-block-10">
              Based on your expertise, we feel you may be interested in these
              professionals
            </div>
            <router-link
              data-w-id="7a736092-9bb6-5ac0-2e0b-139e7451ea07"
              to="/become-a-professional"
              class="timeslot-button w-button"
              >Get started</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";

export default {
  name: "RightSideMenu",
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      professionalList: state => state.professional.professionals,
      customerInfo: state => state.customer.customerInfo
    })
  },
  methods: {
    profile(professional) {
      StoreUtils.commit(
        StoreUtils.mutations.professional.SET_PROFESSIONAL,
        professional
      );
      RouterUtils.changeRouteUrlTo(
        `/professionals/${professional.professionalId}`
      );
    },
    goToProfile() {
      RouterUtils.changeRouteUrlTo(`/clients/${this.userInfo.customerId}`);
    }
  },
  mounted() {
    StoreUtils.dispatch(StoreUtils.actions.professional.READ_PROFESSIONALS);
  }
};
</script>

<style scoped>
.profile-name {
  text-decoration: none;
}
.profile-name:hover,
.profile-name:active {
  text-decoration: none;
}
</style>
